import { createApp } from "vue";
import App from "./pages/App.vue";
import router from "./router";
import store from "./store";
import "@/assets/reset.scss";
import "@/assets/rem.scss";
import "@/assets/common.scss";
import i18n from "./i18n";

const app = createApp(App);

app.provide("$t", i18n).use(router).use(store).mount("body");
